import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "@env/environment";
import { Category } from '@core/interfaces';

@Injectable()
export class CategoryService {
    constructor(private http: HttpClient) {
    }

    GetAll(): Observable<Category[]> {
      return this.http.get<Category[]>(`${environment.apiUrl}api/category/getall`);
    }

    GetAllCountries(): Observable<string[]> {
      return this.http.get<string[]>(`./assets/json/countries.json`);
    }
}

